// modules
import { addModal } from 'weblite-web-modal-viewer'
// component
import { RemoveMenu } from './remove-menu'

const COMPONENT_ID = 'removeMenu'

interface Prop {
  onRemove: () => unknown
}

export const showRemoveMenu = (props: Prop, preventBackClick = false) =>
  addModal({ id: COMPONENT_ID, props, preventBackClick })

export default {
  [COMPONENT_ID]: { Component: RemoveMenu },
}
